import React, { useEffect } from 'react';
import { FiX, FiCheckCircle, FiAlertCircle, FiInfo } from 'react-icons/fi';

function Toast({ message, type = 'info', onClose, duration = 3000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const icons = {
    success: <FiCheckCircle className="text-green-500" />,
    error: <FiAlertCircle className="text-red-500" />,
    info: <FiInfo className="text-blue-500" />,
  };

  const bgColors = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    info: 'bg-blue-50 border-blue-200',
  };

  const textColors = {
    success: 'text-green-800',
    error: 'text-red-800',
    info: 'text-blue-800',
  };

  return (
    <div className={`fixed top-4 right-3 sm:right-4 z-50 glass-strong ${textColors[type]} rounded-2xl shadow-2xl p-4 min-w-[280px] sm:min-w-[300px] max-w-[calc(100vw-2rem)] sm:max-w-md animate-slideUp flex items-start gap-3 backdrop-blur-md`}>
      <div className="flex-shrink-0 text-xl sm:text-2xl mt-0.5">
        {icons[type]}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium text-sm sm:text-base break-words">{message}</p>
      </div>
      <button
        onClick={onClose}
        className="flex-shrink-0 text-gray-400 hover:text-gray-700 transition-colors p-1 hover:bg-white/20 rounded-lg"
        aria-label="Close"
      >
        <FiX className="text-lg" />
      </button>
    </div>
  );
}

export default Toast;
